/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import type { FunctionComponent } from 'react';
import React from 'react';

// eslint-disable-next-line @trello/less-matches-component
import styles from './PowerUp.less';
import Badges from './Badges';
import type { DescriptionAtomProps } from './types';
import { PowerUpListingOverview } from 'app/src/components/PowerUpListingOverview';

export const DescriptionAtom: FunctionComponent<DescriptionAtomProps> = ({
  className,
  overview,
  icon,
  name,
  promotional,
  staffPick,
  integration,
  usage,
  deprecation,
  ...props
}) => (
  <div className={classNames(styles.descriptionAtomGrid, className)}>
    <div className={styles.logoNameGrid}>
      <span
        className={styles.icon}
        style={{
          backgroundImage: `url(${icon.url})`,
        }}
      />
      <span className={styles.name} title={name}>
        {name}
      </span>
    </div>
    {props.button}
    <PowerUpListingOverview overview={overview} deprecation={deprecation} />
    <Badges
      promotional={promotional}
      usage={usage}
      staffPick={staffPick}
      integration={integration}
      hideInstallCues={Boolean(deprecation?.sunsetDate)}
    />
  </div>
);

export const StyledDescriptionAtom: FunctionComponent<DescriptionAtomProps> = ({
  className,
  ...props
}) => (
  <DescriptionAtom
    className={classNames(styles.descriptionAtom, className)}
    {...props}
  />
);

export default StyledDescriptionAtom;
